import { useAppDispatch, useAppSelector } from '../../../../App/redux/store';
import Button from '../../../../components/Assets/Button';
import IndividualCircularLoader from '../../../../components/Loader/IndividualCircularLoader';
import { APIStatus } from '../../../../services/axiosEnums';
import { getAuthState } from '../../authSlice';
import { logoutThunk } from '../../services/authThunks';
import styles from './userConnexionProcess.module.scss';
function UserConnexionProcess() {
  const { user } = useAppSelector(getAuthState);
  const dispatch = useAppDispatch();

  const handleLogout = () => {
    dispatch(logoutThunk());
  };

  const handleSupportContact = () => {
    window.open('mailto:support@urbanease.io', '_blank');
  };

  if (user.apiStatus === APIStatus.REJECTED && !user.result) {
    return (
      <div className={styles.userConnexionProcess}>
        <h1>Erreur de connexion</h1>
        <div className={styles.body}>
          <p>L&apos;utilisateur n&apos;a pas pu être chargé.</p>
          <p>Contacter le support si le problème se reproduit.</p>
        </div>
        <div className={styles.buttonContainer}>
          <Button
            btnType="button"
            primary
            btnContent="CONNEXION MANUELLE"
            handleClick={handleLogout}
          />
          <Button
            btnType="button"
            primary
            btnContent="CONTACTER LE SUPPORT"
            handleClick={handleSupportContact}
          />
        </div>
      </div>
    );
  }

  // if userApiStatus === pending
  if (user.apiStatus === APIStatus.PENDING && !user.result) {
    return (
      <div className={styles.userConnexionProcess}>
        <IndividualCircularLoader size={200} />
        <p className={styles.loaderMessage}>{`Chargement de l'utilisateur ...`}</p>
      </div>
    );
  }

  // if (user.apiStatus === APIStatus.FULFILLED) {
  return null;
  // }
}

export default UserConnexionProcess;
